<nav class="step-container" role="progressbar" [attr.aria-valuenow]="currentStep" [attr.aria-valuemin]="1"
  [attr.aria-valuemax]="steps.length">
  <ol class="step-list" role="list">
    <li *ngFor="let step of steps; let i = index; let last = last; trackBy: trackByStepNumber" class="step-item" role="listitem"
      [attr.aria-label]="getStepAriaLabel(step, i)">
      <div class="step-circle" [ngClass]="{'completed': isStepCompleted(step), 'active': isStepActive(step)}"
        [attr.aria-current]="isStepActive(step) ? 'step' : 'false'">
        <ng-container *ngIf="isStepCompleted(step); else stepNumber">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </ng-container>
        <ng-template #stepNumber>
          <span aria-hidden="false">{{ step.number }}</span>
        </ng-template>
      </div>
      <div class="step-label" [ngClass]="{'completed': isStepCompleted(step), 'active': isStepActive(step)}">
        {{ step.label | translate }}
      </div>
      <div *ngIf="!last" class="step-line" [ngClass]="{'completed': steps[i+1].completed || isStepCompleted(step)}"
        aria-hidden="true"></div>
    </li>
  </ol>
</nav>